export default __webpack_public_path__ + "static/media/logo-usine-nouvelle.064fdf55.svg";